export default __webpack_public_path__ + "static/media/warning.4513ec71.svg";